import dayjs, { Dayjs } from 'dayjs'
import DateFormat from '../types/enums/DateFormat'

export const getMinDate = (startDate: dayjs.Dayjs | null) => {
  return dayjs(startDate).isAfter(dayjs()) ? startDate : dayjs()
}

export const capitalizeMonthName = (date: Dayjs): string => {
  const monthName = date.format(DateFormat.MonthName)
  return monthName.charAt(0).toUpperCase() + monthName.slice(1)
}

export const formatStringDate = (date: string | null | undefined, withTime?: boolean) => {
  if (!date) return ''
  return dayjs(date).format(withTime ? DateFormat.DayMonthYearTime : DateFormat.DayMonthYear)
}
